/**
 * The client's trust window on reads that show what can be booked or what is
 * booked (admin-cache-invalidation-rule D7, Gabriel 2026-09-16). The admin's
 * phone cannot reach this Mini App, so these never trust a cached copy:
 * navigating back to the screen refetches behind the shown copy, and the Mini
 * App returning to the foreground refetches it. Booking itself is checked by
 * the server, so a stale row can only show, never book.
 */
export const BOOKING_TRUTH_QUERY = {
  staleTime: 0,
  refetchOnWindowFocus: true,
} as const;

/**
 * The client's dashboard read (`GET /booking-hub`), the app's Home and the website's alike
 * (shared-client-screens row H11): never trusted from cache, re-read on return and on
 * reconnect, retried on a server or network failure and on a rate limit, never on another
 * 4xx (the client must sign in again).
 */
export const DASHBOARD_QUERY = {
  ...BOOKING_TRUTH_QUERY,
  refetchOnMount: true,
  refetchOnReconnect: true,
  retry: (failureCount: number, error: { status?: number }) => {
    const status = error.status ?? 0;
    // A rate limit is temporary.
    if (status === 429) return failureCount < 2;
    if (status >= 400 && status < 500) return false;
    return failureCount < 2;
  },
  // Kept 30 minutes for background re-reads.
  gcTime: 1000 * 60 * 30,
} as const;
